import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    addFeedbackForPathAndDocId({ commit }, { path, docId, feedback }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const docRef = db.doc(`${path}/${docId}`);
        docRef.get().then(doc => {
          if (doc.exists) {
            const feedbacks = doc.data().feedbacks ? doc.data().feedbacks : [];
            feedbacks.push(feedback);

            return docRef
              .update({
                _updated_at: new Date(),
                feedbacks: feedbacks
              })
              .then(() => res(true));
          }
        });
      });
    },
    addOutputObjForPathAndDocId(
      { commit },
      { path, docId, outputObj, updatedBy }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const docRef = db.doc(`${path}/${docId}`);
        docRef.get().then(doc => {
          if (doc.exists) {
            return docRef
              .update({
                _updated_at: new Date(),
                _updated_by: updatedBy ? updatedBy : null,
                outObj: outputObj
              })
              .then(() => {
                res(true);
              });
          }
        });
      });
    },
    getAudioForPathAndDocId({ commit }, { path, docId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const collectionRef = db.collection(path);
        collectionRef
          .where("docId", "==", docId)
          .get()
          .then(querySnapshot => {
            if (
              querySnapshot.docs &&
              Array.isArray(querySnapshot.docs) &&
              querySnapshot.docs.length > 0
            ) {
              res(querySnapshot.docs[0].data());
            } else {
              res(null);
            }
          }).catch((err) =>{
               rej(err);
        });
      });
    }
  },
  //synchronous
  mutations: {}
};
